import React, { useMemo, useState } from 'react';
import BsModal from '../Common/BsModal';
import ajaxConfig from '../../util/remote/ajaxConfig';
import Notification from '../Common/Notification';


const InviteUserModal = ({
  show,
  onClose,
  onSuccess,
  roles = [],
  businessName,        // optional, for nicer copy
}) => {
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('');
  const [note, setNote] = useState(''); // optional message to invitee
  const [submitting, setSubmitting] = useState(false);
  const [notify, setNotify] = useState(null);

  const emailIsValid = useMemo(() => {
    // simple but solid email validation
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  }, [email]);

  const canSubmit = emailIsValid && !!role && !submitting;

  const handleSubmit = async () => {
      setNotify(null);
      setSubmitting(true);
      const server_response = await ajaxConfig.inviteUser({username: email.trim(), role_id: role, note});
    setSubmitting(false);
      if(server_response.status === "OK"){
        setNotify(<Notification type="success" message="Invitation sent successfully!" />);
        setTimeout(() => {
            // reset & close
            setEmail('');
            setRole('');
            setNote('');
            onSuccess?.();
            setNotify(null);
        }, 1000);
        
      } else {
        setNotify(<Notification type="danger" message={server_response.message || 'Failed to send invite.'} />);
      }
     
   
  };

  const renderRoleOptions = () => {
    if(Array.isArray(roles) && roles.length > 0) {
      return roles.map((r) => (
        <option key={r.id} value={r.id}>
          {r.role_name}
        </option>
      ));
    }
    return <></>;
  };

  return (
    <BsModal
      show={show}
      onClose={onClose}
      title="Invite a User to Administer Your Business"
      footer={
        <>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={!canSubmit}
          >
            {submitting ? (
              <>
                <i className="fa fa-spinner fa-spin mr-1" /> Sending…
              </>
            ) : (
              <>
                <i className="fa fa-paper-plane mr-1" /> Send Invite
              </>
            )}
          </button>
        </>
      }
    >
      <div className="text-dark">
        <p className="mb-2">
          Invite a teammate to help administer
          {businessName ? <> <b>{businessName}</b></> : ' your business'} on
          OpenFi.
        </p>
        <div className="alert alert-info py-2">
          <i className="fa fa-info-circle mr-1" />
          <b>Heads up:</b> Administrators are invited by email. The person you
          invite must already have an OpenFi account registered with the same
          email address.
        </div>

        {notify}

        <div className="form-group">
          <label htmlFor="inviteEmail">OpenFi Email</label>
          <input
            type="email"
            className="form-control"
            id="inviteEmail"
            placeholder="user@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            required
          />
          {!emailIsValid && email.length > 0 && (
            <small className="form-text text-danger">
              Please enter a valid email address.
            </small>
          )}
          <small className="form-text text-muted">
            We’ll send an invitation to this address.
          </small>
        </div>

        <div className="form-group">
          <label htmlFor="inviteRole">Role</label>
          <select
            className="form-control"
            id="inviteRole"
            value={role}
            onChange={(e) => setRole(e.target.value)}
            required
          >
            <option value="">Select a role…</option>
            {renderRoleOptions()}
          </select>
          <small className="form-text text-muted">
            <b>Admin</b>: full access • <b>Manager</b>: manage plans/routers/users •{' '}
            <b>Support</b>: view and assist sessions • <b>Billing</b>: invoices & payments •{' '}
            <b>Viewer</b>: read‑only
          </small>
        </div>

        {/* <div className="form-group mb-0">
          <label htmlFor="inviteNote">Message (optional)</label>
          <textarea
            className="form-control"
            id="inviteNote"
            rows="2"
            placeholder="Add a short message to the invite (optional)"
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
          <small className="form-text text-muted">
            This note appears in the invitation email.
          </small>
        </div> */}
      </div>
    </BsModal>
  );
};

export default InviteUserModal;
